<!-- Scroll Top -->
<a href="#" id="scroll-top" class="scroll-top d-flex align-items-center justify-content-center"><i class="bi bi-arrow-up-short"></i></a>

<header id="header" class="header d-flex align-items-center fixed-top">
  <div class="header-container container-fluid container-xl position-relative d-flex align-items-center justify-content-between">

    <a href="https://rayanbpms.ir/" class="logo d-flex align-items-center me-auto me-xl-0">
      <!-- Uncomment the line below if you also wish to use an image logo -->
       <img src="img/logo.png" alt="سیستم مدیریت فرآیندهای رایان"> 
      <!--<h1 class="sitename"><img src="img/logo.png" class="img-fluid" alt=""></h1>-->
    </a>

    <nav id="navmenu" class="navmenu">
      <ul>
        <li><a href="https://rayanbpms.ir/" class="active">خانه</a></li>
        <li><a href="#about">درباره ما</a></li>
        <li><a href="#features">نقاط قوت</a></li>
        <li><a href="#testimonials">تیم ما</a></li>
        <li><a href="#services">خدمات ما</a></li>
        <!--<li><a href="#pricing">پلان‌ها</a></li>-->
        <!--<li class="dropdown">
    <a href="#"><span>Dropdown</span> <i class="bi bi-chevron-down toggle-dropdown"></i></a>
    <ul>
      <li><a href="#">Dropdown 1</a></li>
      <li class="dropdown">
        <a href="#"><span>Deep Dropdown</span> <i class="bi bi-chevron-down toggle-dropdown"></i></a>
        <ul>
          <li><a href="#">Deep Dropdown 1</a></li>
          <li><a href="#">Deep Dropdown 2</a></li>
          <li><a href="#">Deep Dropdown 3</a></li>
          <li><a href="#">Deep Dropdown 4</a></li>
          <li><a href="#">Deep Dropdown 5</a></li>
        </ul>
      </li>
      <li><a href="#">Dropdown 2</a></li>
      <li><a href="#">Dropdown 3</a></li>
      <li><a href="#">Dropdown 4</a></li>
    </ul>
  </li>-->
        <li><a href="#contact">ارتباط با ما</a></li>
      </ul>
      <i class="mobile-nav-toggle d-xl-none bi bi-list"></i>
    </nav>

    <a class="btn-getstarted" href="#contact">ارسال درخواست</a>

  </div>
</header>

<router-outlet />

<footer id="footer" class="footer">

  <div class="container footer-top">
    <div class="row gy-4">
      <div class="col-lg-4 col-md-6 footer-about">
        <a href="index.html" class="logo d-flex align-items-center">
          <span class="sitename"><img src="img/logo.png" alt="سیستم مدیریت فرآیندهای رایان"> </span>
        </a>
        <div class="footer-contact pt-3">
          <p>تهران، ملاصدرا</p>
          <p>بعداز چهارراه شیخ بهائی، پلاک 171 و 173</p>
          <p class="mt-3"><strong>تماس:</strong> <span class="dir-left d-inline-block"><a href="tel:09357955269">+98 935 795 52 69</a></span></p>
          <p><strong>پست الکترونیکی:</strong> <span><a href="mailto:rayanbpms@gmail.com">rayanbpms&#64;gmail.com</a></span></p>
        </div>
        <div class="social-links d-flex mt-4">
          <a href="https://www.instagram.com/rayanbpms"><i class="bi bi-instagram"></i></a>
          <a href="https://t.me/rayanbpms"><i class="bi bi-telegram"></i></a>
          <a href="https://whatsapp.com/channel/0029Vb2hYtc6LwHja5WIa20R"><i class="bi bi-whatsapp"></i></a>
          <a href="https://www.linkedin.com/in/rayanbpms"><i class="bi bi-linkedin"></i></a>
        </div>
      </div>

      <div class="col-lg-2 col-md-3 footer-links">
        <h4>لینک‌های مهم</h4>
        <ul>
          <li><a href="https://rayanbpms.ir/" class="active">خانه</a></li>
          <li><a href="#about">درباره ما</a></li>
          <li><a href="#features">نقاط قوت</a></li>
          <li><a href="#testimonials">تیم ما</a></li>
          <li><a href="#services">خدمات ما</a></li>
          <li><a href="#contact">ارتباط با ما</a></li>
        </ul>
      </div>

      <!--<div class="col-lg-2 col-md-3 footer-links">
        <h4>Our Services</h4>
        <ul>
          <li><a href="#">Web Design</a></li>
          <li><a href="#">Web Development</a></li>
          <li><a href="#">Product Management</a></li>
          <li><a href="#">Marketing</a></li>
          <li><a href="#">Graphic Design</a></li>
        </ul>
      </div>

      <div class="col-lg-2 col-md-3 footer-links">
        <h4>Hic solutasetp</h4>
        <ul>
          <li><a href="#">Molestiae accusamus iure</a></li>
          <li><a href="#">Excepturi dignissimos</a></li>
          <li><a href="#">Suscipit distinctio</a></li>
          <li><a href="#">Dilecta</a></li>
          <li><a href="#">Sit quas consectetur</a></li>
        </ul>
      </div>

      <div class="col-lg-2 col-md-3 footer-links">
        <h4>Nobis illum</h4>
        <ul>
          <li><a href="#">Ipsam</a></li>
          <li><a href="#">Laudantium dolorum</a></li>
          <li><a href="#">Dinera</a></li>
          <li><a href="#">Trodelas</a></li>
          <li><a href="#">Flexo</a></li>
        </ul>
      </div>-->

    </div>
  </div>

  <div class="container copyright text-center mt-4">
    <p>© <span>تمامی حقوق متعلق به (رایان BPMS)</span>&nbsp;<img src="img/logo.png" width="56" alt="فرآیندهای رایان">&nbsp;<span>می‌باشد.</span></p>
    <div class="credits">
      <!-- All the links in the footer should remain intact. -->
      <!-- You can delete the links only if you've purchased the pro version. -->
      <!-- Licensing information: https://bootstrapmade.com/license/ -->
      <!-- Purchase the pro version with working PHP/AJAX contact form: [buy-url] -->
      <!--Designed by <a href="https://bootstrapmade.com/">BootstrapMade</a>-->
    </div>
  </div>

</footer>

